import {dateWordShort} from "../../../../../../../helper/helper";
import {useEffect, useState} from "react";
import {Star} from "../../../../../../../assets/icons";
import Usefetchdata from "../../../../../../../hooks/usefetchdata";
import ApiDatabase from "server";
import TableRow from "../../../../../../../components/table/components/TableRow";
import TableCell from "../../../../../../../components/table/components/TableCell";
import {useLocation} from "react-router-dom";

const TbodyListVivier = ({champsBody, navigateToFicheVivier, departments = []}) => {
    const {userData} = Usefetchdata()
    const [isAdminFavorite, setIsAdminFavorite] = useState(false)
    const token = localStorage.getItem('xsrfToken')
    const location = useLocation();
    const [selectedId, setSelectedId] = useState(null);
    
    const departmentCounts = champsBody?.departmentCounts || {};
    const userCount = champsBody?.userCount ?? champsBody?.user_preferences?.length ?? 0;
    
    //get selectedVivier in params
    const params = new URLSearchParams(window.location.search)
    const selectedVivier = params.get('selectedVivier')
    
    useEffect(() => {
        if (selectedVivier) {
            setSelectedId(selectedVivier);
        }
    }, [selectedVivier]);

    useEffect(() => {
        if (userData?._id && champsBody) {
            if (champsBody.admin_favorites?.length > 0) {
                for (let i = 0; i < champsBody.admin_favorites.length; i++) {
                    if (champsBody.admin_favorites[i].id_user === userData._id) {
                        setIsAdminFavorite(true)
                        break
                    }
                }
            }
        }
    }, [userData, champsBody])

    const removeAdminVivierFavorite = (idVivier) => {
        ApiDatabase.deleteAdminVivierFavorite({token, idVivier}, (data) => {
                setIsAdminFavorite(false)
            },
            (err) => {
                console.warn(err)
            })
    }

    const addAdminVivierFavorite = (idVivier) => {
        ApiDatabase.postAdminVivierFavorite({token, idVivier}, (data) => {
                setIsAdminFavorite(true)
            },
            (err) => {
                console.warn(err)
            })
    }

    useEffect(() => {
        //scroll to specific div
        if (selectedVivier) {
            const elmnt = document.getElementById(selectedVivier);
            if (elmnt) elmnt.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        }
    }, [selectedVivier]);

    return (
        <>
            <TableRow
                id={champsBody._id}
                itemId={champsBody._id}
                selectedId={selectedId}
                onClick={(id) => {
                    setSelectedId(id);
                    navigateToFicheVivier(id);
                }}
            >
                <TableCell position="first" stickyLeft={true} isSelected={selectedId === champsBody._id}>
                    <p className="text-sm text-gray-500">
                        {champsBody.name}
                    </p>
                </TableCell>
                <TableCell>
                    <p className="text-sm text-gray-500">
                        {userCount}
                    </p>
                </TableCell>
                {departments.map((dept) => (
                    <TableCell key={dept}>
                        <p className="text-sm text-gray-500" title={dept}>
                            {departmentCounts[dept] || 0}
                        </p>
                    </TableCell>
                ))}
                <TableCell>
                    <p className="text-sm text-gray-500">
                        {dateWordShort(champsBody.createdAt)}
                    </p>
                </TableCell>
                <TableCell>
                    <p className="text-sm text-gray-500">
                        {dateWordShort(champsBody.updatedAt)}
                    </p>
                </TableCell>
                <TableCell position="last">
                    {champsBody._id !== '64e8cfd10b4f73f442432c9f' && (
                        <>
                            {isAdminFavorite ? (
                                <div className={'cursor-pointer w-8 h-8 flex justify-center items-center'} onClick={(e) => {
                                    e.stopPropagation();
                                    removeAdminVivierFavorite(champsBody._id);
                                }}>
                                    <Star wh={20} color={'#FF9600'}/>
                                </div>
                            ) : (
                                <div className={'cursor-pointer w-8 h-8 flex justify-center items-center'} onClick={(e) => {
                                    e.stopPropagation();
                                    addAdminVivierFavorite(champsBody._id);
                                }}>
                                    <Star wh={20} color={'#F3F4F6'}/>
                                </div>
                            )}
                        </>
                    )}
                </TableCell>
            </TableRow>
        </>
    )
}

export default TbodyListVivier